/**
 * 删除部门
 */
import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message } from 'antd';

class DeptModal extends React.Component {
    formRef = React.createRef();
    state = {
        confirmLoading: false,
    }

    _handleOk = () => {
        const { id } = this.props.param || {};
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.delDeptInfo', { id }, 'POST').then(() => {
            message.success('删除成功');
            this.props.closeModal(true);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading } = this.state;

        return (
            <Modal
                width={600}
                centered
                title={this.props.title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div>您是否删除当前部门，<span style={{ color: 'red' }}>删除后当前部门员工所有权限关闭</span>，无法使用</div>
            </Modal>
        );

    }
}

DeptModal.propTypes = {
    title: PropTypes.string.isRequired, // 弹框标题
    closeModal: PropTypes.func.isRequired, // 关闭弹框
    param: PropTypes.object, // 入参对象
    type: PropTypes.string, // 编辑类型
};

export default DeptModal;
